module.exports = __webpack_public_path__ + "img/vertical_6_4_8003.409eb4f7.png";